import { Link, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export function StudentLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="admin-shell">
      <header className="admin-header">
        <Link to="/student" className="brand">
          Exam Platform
        </Link>
        <div className="user-area">
          {user && <span>{user.username}</span>}
          <button onClick={() => void logout()}>Log out</button>
        </div>
      </header>
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
